import { render, staticRenderFns } from "./SelectItem.vue?vue&type=template&id=db248ccc&scoped=true"
import script from "./SelectItem.vue?vue&type=script&lang=js"
export * from "./SelectItem.vue?vue&type=script&lang=js"
import style0 from "./SelectItem.vue?vue&type=style&index=0&id=db248ccc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db248ccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db248ccc')) {
      api.createRecord('db248ccc', component.options)
    } else {
      api.reload('db248ccc', component.options)
    }
    module.hot.accept("./SelectItem.vue?vue&type=template&id=db248ccc&scoped=true", function () {
      api.rerender('db248ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/SelectItem.vue"
export default component.exports